import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PrivacyPage() {
  return (
    <Box 
      sx={{ 
        bgcolor: '#000000',
        minHeight: '100vh',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowX: 'hidden'
      }}
    >
      <Header />
      <Box
        sx={{
          pt: '84px',
          pb: '100px'
        }}
      >
        <Container 
          maxWidth="md"
          sx={{
            color: 'white',
            p: { xs: 2, sm: 4 }
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              color: '#ff0000',
              fontWeight: 600,
              mb: 4,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              textShadow: '0 0 10px rgba(255, 0, 0, 0.3)'
            }}
          >
            Privacy Policy – Screamify™
          </Typography>

          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            At Screamify™, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            1. Information We Collect
          </Typography>
          <Box component="ul" sx={{ mt: 1, pl: 3 }}>
            <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
              Personal information such as name, email, and shipping address when you make a purchase or create an account.
            </Typography>
            <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
              Payment information is processed securely via third-party providers like Stripe; we do not store your payment details.
            </Typography>
            <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
              Analytics data (via Google Analytics) to help us understand how users interact with our website.
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            2. How We Use Your Information
          </Typography>
          <Box component="ul" sx={{ mt: 1, pl: 3 }}>
            <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
              To process transactions and deliver products.
            </Typography>
            <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
              To communicate with you about your orders or updates.
            </Typography>
            <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
              To improve our website and offerings based on user behavior.
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            3. Sharing Your Information
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            We do not sell or share your personal information with third parties, except as needed to fulfill your order (e.g., shipping companies, payment processors).
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            4. Security
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            We use industry-standard security measures to protect your data. However, no method of transmission over the internet is 100% secure.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            5. Your Rights
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            You have the right to access, update, or delete your personal information by contacting us.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            6. Cookies
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            We use cookies to enhance your browsing experience. You can control cookie settings in your browser at any time.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            7. Changes to This Policy
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            We may update this Privacy Policy occasionally. Changes will be posted on this page with the updated effective date.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            Contact
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            If you have questions about this policy, please contact us at: info@screamify.com
          </Typography>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default PrivacyPage; 